import React from 'react';
import { Button, Col } from 'reactstrap';
import InfoRow from './InfoRow';
import T from 'i18n-react';

const TopUpEwalletPage = ({history}) => (
    <div className="col-sm-12">
                     <h4 className= "title-screen">
                       <T.text tag='span' text="menu_top_up_wallet"/>
                     </h4>
                     <br/>
                <div className="row">

                        <div className="col prepaid-card-block">
                            <Button color="warning"
                                className="curr-pointer prepaid-btn"
                                onClick={() => {history.push('/prepaidCard')}}>
                                <T.text tag='span' text="prepaid_card"/>
                            </Button>
                        </div>
                        <div className="col prepaid-card-block">
                        <Button color="warning"
                            className="curr-pointer credit-btn"
                            onClick ={() => {history.push('/simpleCreditCard')}}>
                            <T.text tag='span' text="credit_card"/>
                         </Button>
                        </div>
                    </div>

                    <br />
                    <div className="row btm-cnt-wallet">
                      <div className="col-md-12">
                        <Button color="warning" className="back-btn"
                        onClick={()=> {history.push('/welcome')}}>
                          <T.text tag='span' text="back"/>
                        </Button>
                      </div>
                   </div>
            </div>

);
export default TopUpEwalletPage;


{/* <Button color="warning"
className="curr-pointer credit-btn"
onClick ={() => {history.push('/creditCard')}}>
TOP UP E-WALLET <br />
WITH CREDIT CARD
</Button> */}



// WEBPACK FOOTER //
// ./src/components/TopUpEwalletPage.js